export const authConstants = {
  // 登入
  LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
  LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
  LOGIN_FAILURE: "AUTH_LOGIN_FAILURE",
  REFRESH_CREDENTIAL: "AUTH_REFRESH_CREDENTIAL_SUCCESS",
  // 登出
  LOGOUT: "AUTH_LOGOUT"
};
